import React, {memo, useCallback, useEffect, useMemo, useState} from "react"
import {useRPC} from "../../../../hooks/rpc"
import {useSelector} from "react-redux"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {useQuestion} from "../../../../hooks/question"
import {useLocalization} from "../../../../hooks/localization"
import {SettingCheckBoxComponent} from "../../../../components/Settings/SettingCheckboxComponent"

const BACK_URL = "/settings/users"
export const AuthoritySettings = memo(function AuthoritySettings() {
    const {t} = useLocalization()
    const question = useQuestion()
    const [rpc] = useRPC()
    const config = useSelector(state => state.control.config)
    const [authorityStatus, setAuthorityStatus] = useState(config?.advanced_authorization_status || false)
    const authorityStatusMessage = useMemo(
        () =>
            authorityStatus
                ? t(
                      "authority.are_you_sure_you_want_to_close?_you_will_need_to_restart_your_dashboard_after_this_process"
                  )
                : t(
                      "authority.are_you_sure_you_want_to_open_it?_you_will_need_to_restart_your_dashboard_after_this_process"
                  ),
        [t, authorityStatus]
    )
    const onClickSetAuthorityStatus = useCallback(() => {
        let newValue = authorityStatus
        question(authorityStatusMessage, () => {
            if (newValue) {
                newValue = false
            } else {
                newValue = true
            }
            setAuthorityStatus(newValue)
            rpc.updateAdvancedAuthorizationStatus(newValue)
        })
    }, [question, rpc, authorityStatus, authorityStatusMessage])

    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <SettingsPageContainer className="service-edit" buttons={[]} backUrl={BACK_URL}>
                <div className="content-divider">
                    <div className="content-wrapper">
                        <SettingCheckBoxComponent
                            label={t("authority.adv_auth")}
                            set={onClickSetAuthorityStatus}
                            value={authorityStatus}
                        />
                    </div>
                    <div className="content-wrapper"></div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
